// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1JXBX","signatureBlock":"Footer_signatureBlock__5j_TS","signature":"Footer_signature__3-fyY"};